import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const CommunityGuidelines = () => {
  const [expandedSection, setExpandedSection] = useState(null);

  const guidelines = [
    {
      id: 'appropriate',
      title: 'Appropriate Content',
      icon: 'CheckCircle2',
      content: `Share your genuine feelings and experiences. This is a safe space for emotional expression, struggles, and personal stories. Focus on your own journey and emotions rather than attacking others.`
    },
    {
      id: 'supportive',
      title: 'Supportive Interactions',
      icon: 'Heart',
      content: `Use reactions thoughtfully. "I relate to you" shows empathy, "you are correct" validates feelings, and "not the best choice" should be used constructively. Remember, everyone is fighting their own battle.`
    },
    {
      id: 'privacy',
      title: 'Privacy & Anonymity',
      icon: 'Shield',
      content: `Your posts are anonymous, but avoid sharing specific identifying details like full names, addresses, or workplace information. Our anonymization tool helps, but your awareness is the first line of defense.`
    },
    {
      id: 'respect',
      title: 'Respect & Boundaries',
      icon: 'Users',
      content: `Respect others' experiences even if they differ from yours. Avoid judgment, unsolicited advice, or dismissive reactions. This community thrives on mutual understanding and compassion.`
    }
  ];

  const toggleSection = (id) => {
    setExpandedSection(expandedSection === id ? null : id);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="flex items-center justify-center w-8 h-8 md:w-10 md:h-10 bg-primary/10 rounded-lg">
          <Icon name="BookOpen" size={20} color="var(--color-primary)" strokeWidth={2} />
        </div>
        <h3 className="text-base md:text-lg font-semibold text-foreground">
          Community Guidelines
        </h3>
      </div>
      <div className="space-y-2">
        {guidelines?.map((guideline) => (
          <div
            key={guideline?.id}
            className="border border-border rounded-lg overflow-hidden transition-therapeutic"
          >
            <button
              onClick={() => toggleSection(guideline?.id)}
              className="w-full flex items-center justify-between gap-3 p-3 md:p-4 bg-background hover:bg-muted transition-therapeutic focus-ring text-left"
            >
              <div className="flex items-center gap-3 flex-1 min-w-0">
                <Icon
                  name={guideline?.icon}
                  size={18}
                  color="var(--color-primary)"
                  strokeWidth={2}
                />
                <span className="text-sm md:text-base font-medium text-foreground">
                  {guideline?.title}
                </span>
              </div>
              <Icon
                name="ChevronDown"
                size={18}
                strokeWidth={2}
                className={`flex-shrink-0 transition-transform ${
                  expandedSection === guideline?.id ? 'rotate-180' : ''
                }`}
              />
            </button>

            {expandedSection === guideline?.id && (
              <div className="p-3 md:p-4 bg-muted/50 border-t border-border">
                <p className="text-xs md:text-sm text-muted-foreground leading-relaxed">
                  {guideline?.content}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommunityGuidelines;